// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__2Jzv_","consentsList":"PatientConsents_consentsList__2fqf_","consentsListEmpty":"PatientConsents_consentsListEmpty__260qB"};